import { useLazyFetch } from "../utils/apiclient";
import { convoyTessellUrl } from "../utils/urls";
import { getHeaders } from "../utils/apiclient";

export const useListDeploymentStages = () => {
  return useLazyFetch(`${convoyTessellUrl}/apps/tessell/deployment-stages`, {
    headers: { ...getHeaders(), Action: "LIST_ALL" },
  });
};
